import {
  FETCH_BUYERS_QR_REQUEST,
  FETCH_BUYERS_QR_SUCCESS,
  FETCH_BUYERS_QR_ERROR,
} from '../../../actions/widget/ownership'
import { IDLE, FETCHED, FETCHING, FAILED } from '../../../constants/fetchStates'

const initial = {
  holders: [],
  status: IDLE
}

const buyersQr = (state = initial, action) => {
  switch (action.type) {
    case FETCH_BUYERS_QR_REQUEST:
      return {
        ...state,
        status: FETCHING
      }
    case FETCH_BUYERS_QR_SUCCESS:
      let qr = {}

      if (Array.isArray(action.payload) && action.payload.length) {
        qr = (action.payload[0] && action.payload[0].buy) || {}
      } else {
        qr = action.payload
      }

      return {
        ...state,
        qr,
        status: FETCHED
      }
    case FETCH_BUYERS_QR_ERROR:
      return {
        ...state,
        error: action.error,
        status: FAILED
      }
    default:
      return state
  }
}

export default buyersQr
